import * as Yup from 'yup';

export const ValidationUpdateCompanyForm = Yup.object().shape({
    name: Yup.string().required('Required'),
    registrationNumber: Yup.string().required('Required'),
});